import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[wdxFFSubformControlHost]',
    standalone: false,
})
export class FormSubformControlDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
